module.exports = require("./ksh-DE");